export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <img
      src="/assets/founder-seal.jpeg"
      alt="Green Planet Technologies emblem"
      data-testid="brand-logo-image"
      className={`logo-spin ${compact ? "h-10 w-10" : "h-12 w-12"} object-contain`}
    />
    <span className="leading-none">
      <span className="block font-display font-extrabold tracking-tight text-[15px] sm:text-base text-white">
        GREEN PLANET
      </span>
      <span className="block font-mono text-[9px] sm:text-[10px] tracking-[0.35em] text-lime mt-1">
        TECHNOLOGIES
      </span>
    </span>
  </span>
);

export default Logo;
